<template>
  <div class="buttonArea" @click="onClickOpen">
    <div class="buttonMainArea">
      <img src="@/assets/present.svg" />
      <span>景品応募</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "present-button",
  methods: {
    onClickOpen() {
      this.$emit("click-button");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.buttonArea {
  margin: 0.5rem auto;
  width: calc(100% - 1.25rem * 2);
  border-radius: 4px;
  background: #ff7c86;

  .buttonMainArea {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 0;
    color: white;
    font-size: 1.1rem;
    font-weight: 700;
    img {
      height: 1rem;
      margin: auto 0;
      margin-right: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyPage/PresentButton.vue